import { render, staticRenderFns } from "./novel_long_create.vue?vue&type=template&id=4fa5c6da"
import script from "./novel_long_create.vue?vue&type=script&lang=js"
export * from "./novel_long_create.vue?vue&type=script&lang=js"
import style0 from "./novel_long_create.vue?vue&type=style&index=0&id=4fa5c6da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports